import { render, staticRenderFns } from "./ChartPoliticiansByCountry.vue?vue&type=template&id=48861ebe&scoped=true&"
import script from "./ChartPoliticiansByCountry.vue?vue&type=script&lang=js&"
export * from "./ChartPoliticiansByCountry.vue?vue&type=script&lang=js&"
import style0 from "./ChartPoliticiansByCountry.vue?vue&type=style&index=0&id=48861ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48861ebe",
  null
  
)

/* custom blocks */
import block0 from "./ChartPoliticiansByCountry.vue?vue&type=custom&index=0&blockType=tsv"
if (typeof block0 === 'function') block0(component)

export default component.exports